import axiosInstance from "../config/axios.config";

export const getPharmacyReturnsListApi = (params) => {
  return axiosInstance.get(`pharmacy/returns/?${params}`);
};

export const getPharmacyReturnApi = (id) => {
  return axiosInstance.get(`pharmacy/returns/${id}/`);
};

export const addPharmacyReturnApi = (payload) => {
  return axiosInstance.post(`pharmacy/returns/`, payload);
};

export const approvePharmacyReturnItemApi = (returnId, itemId) => {
  return axiosInstance.post(`pharmacy/returns/${returnId}/items/${itemId}/approve/`, {});
};

export const rejectPharmacyReturnItemApi = (returnId, itemId, payload) => {
  return axiosInstance.post(`pharmacy/returns/${returnId}/items/${itemId}/reject/`, payload);
};
